import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import * as Icon from "react-feather"

class Module extends Component {
  state = {
    displayInfo: false,
  }

  toggleInfo = () => {
    const { displayInfo } = this.state

    this.setState({
      displayInfo: !displayInfo,
    })
  }

  render() {
    const { displayInfo } = this.state
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className="course__module">
          <div
            role="button"
            className="course__module-content"
            onClick={this.toggleInfo}
            onKeyPress={this.toggleInfo}
            tabIndex={0}
          >
            <div
              className={`course__module-icon${
                displayInfo ? " course__module-icon--spun" : ""
              }`}
            >
              <Icon.ChevronDown className="icon icon--sm" />
            </div>
            <p className="course__module-text">{blok.text}</p>
          </div>
          <p
            className={`course__module-info${
              displayInfo ? " course__module-info--visible" : ""
            }`}
          >
            {blok.additional}
          </p>
        </div>
      </SbEditable>
    )
  }
}

Module.propTypes = {
  blok: PropTypes.shape({
    text: PropTypes.string,
    additional: PropTypes.string,
  }).isRequired,
}

export default Module
